import type { AxiosError } from 'axios'
import Vue, { PluginObject } from 'vue'
import * as Sentry from '@sentry/vue'
import router from '@/router'
import { isDevMode } from '@/lib/mode'
import { ENABLED_SENTRY } from '@/config/base'

export const SentryPlugin: PluginObject<undefined> = {
  install() {
    if (ENABLED_SENTRY) {
      Sentry.init({
        Vue,
        environment: isDevMode() ? 'development' : 'production',
        dsn: 'https://5996fa4ee70647698894db5b5748e1eb@sentry.fppressa.ru//9',
        ignoreErrors: [
          // Random plugins/extensions
          'top.GLOBALS',
          // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
          'originalCreateNotification',
          'canvas.contentDocument',
          'MyApp_RemoveAllHighlights',
          'http://tt.epicplay.com',
          "Can't find variable: ZiteReader",
          'jigsaw is not defined',
          'ComboSearch is not defined',
          'http://loading.retry.widdit.com/',
          'atomicFindClose',
          // Facebook borked
          'fb_xd_fragment',
          // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
          // reduce this. (thanks @acdha)
          // See http://stackoverflow.com/questions/4113268
          'bmi_SafeAddOnload',
          'EBCallBackMessageReceived',
          // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
          'conduitPage',
        ],
        denyUrls: [
          // Facebook flakiness
          /graph\.facebook\.com/i,
          // Facebook blocked
          /connect\.facebook\.net\/en_US\/all\.js/i,
          // Woopra flakiness
          /eatdifferent\.com\.woopra-ns\.com/i,
          /static\.woopra\.com\/js\/woopra\.js/i,
          // Chrome extensions
          /extensions\//i,
          /^chrome:\/\//i,
          // Other plugins
          /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
          /webappstoolbarba\.texthelp\.com\//i,
          /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
        ],
        integrations: [
          Sentry.browserTracingIntegration({
            router,
          }),
        ],
        tracesSampleRate: 1.0,
        beforeSend(event, hint) {
          const originalException = hint?.originalException as
            | AxiosError
            | undefined

          if (
            originalException?.isAxiosError &&
            originalException.response?.data
          ) {
            const contexts = {
              ...event.contexts,
            }

            contexts.Request = {
              Path: originalException.config.url,
              Method: originalException.config.method?.toUpperCase(),
              Headers: originalException.response.config.headers,
              Payload: originalException.response.config.data,
              Response: originalException.response.data,
            }

            // contexts.Response = {
            //   Data: originalException.response.data,
            // }

            // contexts.Axios = {
            //   'Request headers': originalException.response.config.headers,
            //   'Response headers': originalException.response.headers,
            //   Payload: originalException.response.config.data,
            //   Response: originalException.response.data,
            //   // Response: originalException.response,
            // }

            event.contexts = contexts

            console.dir(event)
            return event
          }

          return event
        },
      })
    }
  },
}
